import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useDetectVersion from 'hooks/useDetectVersion'

export default function TourLayout() {
  const { pathname } = useLocation()
  const { isVersionAccessable } = useDetectVersion()

  if (
    isVersionAccessable &&
    !isVersionAccessable.includes('tour') &&
    !pathname.includes('community') &&
    !pathname.includes('version-notfound')
  ) {
    return <Navigate to="/tour/version-notfound" replace />
  }

  return (
    <div className="tour-theme">
      <Outlet />
    </div>
  )
}
